import makeService from './api';

export default makeService('printing_surface_thicknesses');
